<form (ngSubmit)="addReport(reportForm.valid)" #reportForm="ngForm">
  <h2 class="mb-0" mat-dialog-title>
    {{ "REPORT_ABUSE.REPORT_CHART" | translate }}
  </h2>
  <hr />
  <mat-dialog-content>
    <ul>
      <li>
        <mat-radio-group
          name="reporttype"
          [(ngModel)]="model.title"
          aria-label="Select an option"
        >
          <mat-radio-button value="Unwanted commercial content or spam">{{
            "REPORT_ABUSE.UNWANTED_COMMERCIAL" | translate
          }}</mat-radio-button>
          <mat-radio-button value="Pornography or sexually explicit matrial">{{
            "REPORT_ABUSE.PORNOGRAPHY" | translate
          }}</mat-radio-button>
          <mat-radio-button value="Child Abuse">{{
            "REPORT_ABUSE.CHILD_ABUSE" | translate
          }}</mat-radio-button>
          <mat-radio-button value="Hate speech or graphic violence">{{
            "REPORT_ABUSE.HATE_SPEECH" | translate
          }}</mat-radio-button>
        </mat-radio-group>
      </li>
    </ul>
    <textarea
      #description="ngModel"
      required
      name="report"
      maxlength="1000"
      [(ngModel)]="model.description"
      rows="4"
      class="form-control"
      placeholder="{{ 'REPORT_ABUSE.REPORT_PLACEHOLDER' | translate }}"
    ></textarea>
    <div
      style="color: red"
      class="validation_div"
      *ngIf="description.errors && (description.dirty || reportForm.submitted)"
    >
      <p class="mb-0" *ngIf="description.errors.required">
        {{ "ADD_COMMENT.COMMENT_REQUIRED" | translate }}
      </p>
    </div>
  </mat-dialog-content>
  <hr />
  <mat-dialog-actions class="justify-content-end">
    <button class="btn btn-danger mr-2" mat-dialog-close style="color: #fff !important;">
      {{ "REPORT_ABUSE.CANCEL" | translate }}
    </button>
    <button [disabled]="!disabledStatus && !reportForm.valid" class="btn btn-theme" style="color: #fff !important;">
      <span class="spin" [ngClass]="{ 'icon-loader': disabledStatus }"> </span>
      {{ "REPORT_ABUSE.REPORT" | translate }}
    </button>
  </mat-dialog-actions>
</form>
